var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.667 26.25V18.25C75.667 17.1454 74.7716 16.25 73.667 16.25H27.667C26.5624 16.25 25.667 17.1454 25.667 18.25V26.25",
    stroke: "url(#paint0_linear_4505_9019)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.917 36.25V28.25C81.917 27.1454 81.0216 26.25 79.917 26.25H21.417C20.3124 26.25 19.417 27.1454 19.417 28.25V36.25",
    stroke: "url(#paint1_linear_4505_9019)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.167 51.25V38.25C88.167 37.1454 87.2716 36.25 86.167 36.25H15.167C14.0624 36.25 13.167 37.1454 13.167 38.25V51.25",
    stroke: "url(#paint2_linear_4505_9019)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.917 51.5625C65.917 59.8123 59.2292 66.5 50.9795 66.5V68.5C60.3338 68.5 67.917 60.9168 67.917 51.5625H65.917ZM67.2265 52.25H95.542V50.25H67.2265V52.25ZM96.542 53.25V79.25H98.542V53.25H96.542ZM95.542 80.25H5.79199V82.25H95.542V80.25ZM4.79199 79.25V53.25H2.79199V79.25H4.79199ZM5.79199 52.25H34.7325V50.25H5.79199V52.25ZM50.9795 66.5C42.7297 66.5 36.042 59.8123 36.042 51.5625H34.042C34.042 60.9168 41.6252 68.5 50.9795 68.5V66.5ZM34.7325 52.25C34.3394 52.25 34.042 51.9306 34.042 51.5625H36.042C36.042 50.8511 35.4688 50.25 34.7325 50.25V52.25ZM4.79199 53.25C4.79199 52.6977 5.23971 52.25 5.79199 52.25V50.25C4.13514 50.25 2.79199 51.5931 2.79199 53.25H4.79199ZM5.79199 80.25C5.23971 80.25 4.79199 79.8023 4.79199 79.25H2.79199C2.79199 80.9069 4.13514 82.25 5.79199 82.25V80.25ZM96.542 79.25C96.542 79.8023 96.0943 80.25 95.542 80.25V82.25C97.1988 82.25 98.542 80.9069 98.542 79.25H96.542ZM95.542 52.25C96.0943 52.25 96.542 52.6977 96.542 53.25H98.542C98.542 51.5931 97.1988 50.25 95.542 50.25V52.25ZM67.917 51.5625C67.917 51.9306 67.6196 52.25 67.2265 52.25V50.25C66.4902 50.25 65.917 50.8511 65.917 51.5625H67.917Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4505_9019",
    x1: 14.5832,
    y1: 20.5603,
    x2: 86.135,
    y2: 20.5604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764CB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4505_9019",
    x1: 5.56231,
    y1: 30.5603,
    x2: 95.002,
    y2: 30.5604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764CB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4505_9019",
    x1: -3.45862,
    y1: 42.7155,
    x2: 103.869,
    y2: 42.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764CB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUploadIcon);
export default __webpack_public_path__ + "static/media/drop-upload-icon.bb58b5a5122616ae845e1cbd69e31b82.svg";
export { ForwardRef as ReactComponent };